module.exports = __webpack_public_path__ + "images/enterprise-logo-white.f76e70c826420a9da381.svg";